import { render } from "./Informes.vue?vue&type=template&id=78528639&scoped=true"
import script from "./Informes.vue?vue&type=script&lang=js"
export * from "./Informes.vue?vue&type=script&lang=js"

import "./Informes.vue?vue&type=style&index=0&id=78528639&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78528639"]])

export default __exports__